import React, { useState } from 'react'
import styles from './verticalchecklist.module.scss'
import { images } from '../../assets'

const VerticalCheckList = (props) => {
    const { fieldInfo, value, onChange } = props
    console.log('fieldInfo ', fieldInfo)
    console.log('value ', value)
    const [otherValue, setOtherValue] = useState('')
    return <div className={styles.main}>
        {fieldInfo.options.map(option => {
            const selected = value.indexOf(option) !== -1
            return (
                <div key={option}>
                    <div className={styles.optionDiv}
                         onClick={(e) => onChange(option)}>
                        <img src={selected ? images.checkOn : images.checkOff}
                             alt='check on' />
                        <div className={styles.optionText}>
                            {option}
                        </div>
                    </div>
                    {/* {option === 'Other' && selected &&
                    <textarea
                        name={fieldInfo.name}
                        placeholder={'Minimum 50 characters required.'}
                        value={otherValue}
                        onChange={(e) => {
                            setOtherValue(e.target.value)
                        }}
                        className='form-control'
                    />
                    } */}
                </div>
            )
        })}
    </div>
}

export default VerticalCheckList
